import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { Budget } from "./Budget";
import { OrgBudgetComponent } from "./org.budget.component";
import { BudgetPlanComponent } from "./budget-plan/budget.plan.component";

@TypeManagerDecorator("s25-ng-budget-container")
@Component({
    selector: "s25-ng-budget-container",
    template: `
        @if (init) {
            <div class="budget-container">
                <!-- Budget Navigation Tabs -->
                <div class="budget-navigation">
                    <nav class="budget-tabs">
                        <button
                            class="budget-tab"
                            [class.active]="activeTab === 'overview'"
                            (click)="setActiveTab('overview')"
                        >
                            Overview
                        </button>
                        <button
                            class="budget-tab"
                            [class.active]="activeTab === 'plans'"
                            (click)="setActiveTab('plans')"
                        >
                            Budget Plans
                        </button>
                    </nav>
                </div>

                <!-- Budget Content Area -->
                <div class="budget-content">
                    @if (activeTab === "overview") {
                        <s25-ng-org-budget [itemId]="orgId"></s25-ng-org-budget>
                    }

                    @if (activeTab === "plans") {
                        <s25-ng-budget-plan [orgId]="orgId" (planSaved)="onPlanSaved($event)"></s25-ng-budget-plan>
                    }
                </div>
            </div>
        }
    `,
    styles: `
        .budget-container {
            padding: 1rem;
            max-width: 1400px;
            margin: 0 auto;
        }

        .budget-navigation {
            margin-bottom: 2rem;
            border-bottom: 2px solid #e5e5e5;
        }

        .budget-tabs {
            display: flex;
            gap: 0;
            background: #f8f9fa;
            border-radius: 8px 8px 0 0;
            overflow: hidden;
        }

        .budget-tab {
            flex: 1;
            padding: 1rem 1.5rem;
            background: #f8f9fa;
            border: none;
            border-bottom: 2px solid transparent;
            cursor: pointer;
            font-size: 1rem;
            font-weight: 500;
            color: #666;
            transition: all 0.2s ease;
            min-height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .budget-tab:hover {
            background: #e9ecef;
            color: #333;
        }

        .budget-tab.active {
            background: white;
            color: #2196f3;
            border-bottom-color: #2196f3;
            font-weight: 600;
        }

        .budget-content {
            background: white;
            border-radius: 0 0 8px 8px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            min-height: 500px;
        }

        @media (max-width: 768px) {
            .budget-container {
                padding: 0.5rem;
            }

            .budget-tabs {
                flex-direction: column;
                border-radius: 8px;
            }

            .budget-tab {
                border-bottom: 1px solid #e5e5e5;
                border-radius: 0;
                min-height: 50px;
            }

            .budget-tab:first-child {
                border-radius: 8px 8px 0 0;
            }

            .budget-tab:last-child {
                border-radius: 0 0 8px 8px;
                border-bottom: none;
            }

            .budget-content {
                border-radius: 8px;
                margin-top: 1rem;
            }
        }
    `,
    standalone: true,
    imports: [OrgBudgetComponent, BudgetPlanComponent],
})
export class BudgetContainerComponent implements OnInit {
    @Input() orgId: number;

    init = false;
    activeTab: "overview" | "plans" = "overview";

    constructor(private cd: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.init = true;
        this.cd.detectChanges();
    }

    setActiveTab(tab: "overview" | "plans"): void {
        this.activeTab = tab;
        this.cd.detectChanges();
    }
}
